import firebase from "firebase";
import "firebase/firestore";
// a1lci65L9fsS5RD6iWl6
const yyschool = "/schools/3rjIXFglv9A2d4u15wTV/";

const REAL_APP = true; //bagshsystem
const EYESH_APP = false; //eyesh800
const COOKING_APP = false; //udiinhool
export const omittedDays = [
  {
    month: 11,
    day: 6,
  },
  {
    month: 11,
    day: 7,
  },
  {
    month: 11,
    day: 8,
  },
  {
    month: 11,
    day: 9,
  },
];

const config = !COOKING_APP
  ? {
      apiKey: "AIzaSyDUoVVpLKmXIoFLtToD64dZzeCHFyf7MtI",
      authDomain: "digitalschool-3f1e9.firebaseapp.com",
      projectId: "digitalschool-3f1e9",
      storageBucket: "digitalschool-3f1e9.appspot.com",
      messagingSenderId: "667372416860",
      appId: "1:667372416860:web:036c4483d3da2d923b9b99",
      measurementId: "G-GD56WG73B9",
    }
  : {
      apiKey: "AIzaSyDPEoSiIyIIytU47QG4IrpoXeEOoe3J9vU",
      authDomain: "udiin-hool-5a2b1.firebaseapp.com",
      projectId: "udiin-hool-5a2b1",
      storageBucket: "udiin-hool-5a2b1.appspot.com",
      messagingSenderId: "422346168985",
      appId: "1:422346168985:web:f56a8c10e3883388e4f608",
      measurementId: "G-BD475JKR5X",
    };

const eyeshTmp = {
  eyeshApiKey: "AIzaSyDcriWZpZ_4Tj3YVfyvUKOdHpnCqiV579g",
  eyeshAuthDomain: "eyesh800-ae733.firebaseapp.com",
  eyeshProjectId: "eyesh800-ae733",
  eyeshStorageBucket: "eyesh800-ae733.appspot.com",
  eyeshMessagingSenderId: "637398427967",
  eyeshAppId: "1:637398427967:web:d5cf9168e0245b9b2bcb8a",
};

const eyesh800 = {
  apiKey: eyeshTmp.eyeshApiKey,
  authDomain: eyeshTmp.eyeshAuthDomain,
  projectId: eyeshTmp.eyeshProjectId,
  storageBucket: eyeshTmp.eyeshStorageBucket,
  messagingSenderId: eyeshTmp.eyeshMessagingSenderId,
  appId: eyeshTmp.eyeshAppId,
};

const fbeyesh800 = firebase.initializeApp(eyesh800, "secondary");
export const dbeyesh800 = fbeyesh800.firestore();

const digitalschoolstorage = {
  apiKey: "AIzaSyBUsdngoliI5cloSlIoqpqRMpOJzyEtJ6M",
  authDomain: "digitalschoolstorage.firebaseapp.com",
  projectId: "digitalschoolstorage",
  storageBucket: "digitalschoolstorage.appspot.com",
  messagingSenderId: "370821067954",
  appId: "1:370821067954:web:b1ee09e85f969615ffc5ab",
};

const fbDSStorage = firebase.initializeApp(
  digitalschoolstorage,
  "digitalschoolstorage"
);
export const dbDSStorage = fbDSStorage.firestore();

const app = firebase.initializeApp(config);

// firebase utils
const firestore = firebase.firestore;
const db = firebase.firestore();
const auth = firebase.auth();
export const analytics = app.analytics();
const currentUser = auth.currentUser;

var googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.addScope("email");

const storage = firebase.storage;
const storageRef = firebase.storage().ref();
const imageStorageFolder = "_schoolImages";
/**
 * Upload a file to Firebase Storage and get download URL
 * @param {string} path - Storage path (e.g., 'videos/my-video.mp4')
 * @param {File|Blob} file - File or Blob to upload
 * @returns {Promise<string>} Download URL of uploaded file
 */
export const uploadToStorage = async (path, file) => {
  try {
    const fileRef = storageRef.child(`${imageStorageFolder}/${path}`);
    const snapshot = await fileRef.put(file);
    const downloadUrl = await snapshot.ref.getDownloadURL();
    return downloadUrl;
  } catch (error) {
    console.error("Error uploading to storage:", error);
    throw error;
  }
};

export const uploadToStorageGlobal = async (path, file) => {
  try {
    const fileRef = storageRef.child(`${path}`);
    const snapshot = await fileRef.put(file);
    const downloadUrl = await snapshot.ref.getDownloadURL();
    return downloadUrl;
  } catch (error) {
    console.error("Error uploading to storage:", error);
    throw error;
  }
};


/**
 * Delete a file from Firebase Storage
 * @param {string} path - Storage path of the file to delete (e.g., 'videos/my-video.mp4')
 * @returns {Promise<void>}
 */
export const deleteFromStorage = async (path) => {
  try {
    const fileRef = storageRef.child(`${imageStorageFolder}/${path}`);
    await fileRef.delete();
    console.log(`File at ${path} deleted successfully.`);
  } catch (error) {
    console.error("Error deleting from storage:", error);
    throw error;
  }
};
export const deleteDirectlyFromStorage = async (path) => {
  try {
    const fileRef = storageRef.child(`${path}`);
    await fileRef.delete();
    console.log(`File at ${path} deleted successfully.`);
  } catch (error) {
    console.error("Error deleting from storage:", error);
    throw error;
  }
};
export {
  db,
  auth,
  currentUser,
  googleProvider,
  storage,
  storageRef,
  firestore,
  yyschool,
  COOKING_APP,
  EYESH_APP,
  REAL_APP,
};
